import React from "react";
import { Box, Text, SimpleGrid } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import {
  AiOutlineUser,
  AiOutlineExclamationCircle,
  AiOutlineFile,
  AiOutlineBug,
  AiOutlineQuestionCircle,
  AiOutlinePhone,
} from "react-icons/ai";

const SupportPage = () => {
  return (
    <Box bg="gray.50" minH="100vh">
      {/* Hero Section */}
      <Box
        bg="white"
        pt={{ base: "60px", md: "100px" }}
        pb={{ base: "60px", md: "100px" }}
        px={{ base: 4, md: 8 }}
        textAlign="center"
        borderBottom="1px solid"
        borderColor="gray.200"
      >
        <Text
          fontSize={{ base: "4xl", md: "6xl" }}
          fontWeight="800"
          color="gray.900"
          fontFamily="'Work Sans', sans-serif"
          mb={4}
        >
          Support Center
        </Text>
        <Text
          fontSize={{ base: "lg", md: "xl" }}
          color="gray.600"
          maxW="700px"
          mx="auto"
        >
          We're here to help. Choose a topic to get started.
        </Text>
      </Box>

      {/* Support Topics Grid */}
      <Box py={{ base: 12, md: 16 }} px={{ base: 4, md: 8 }}>
        <SimpleGrid
          columns={{ base: 1, md: 2, lg: 3 }}
          spacing={6}
          maxW="1200px"
          mx="auto"
        >
          {/* Support Topic 1 */}
          <Link
            to="/support/contact-us?type=account-issue"
            style={{ textDecoration: "none" }}
          >
            <Box
              bg="white"
              border="1px solid"
              borderColor="gray.200"
              borderRadius="xl"
              p={8}
              textAlign="center"
              boxShadow="sm"
              transition="all 0.3s ease"
              _hover={{
                boxShadow: "xl",
                borderColor: "orange.400",
                transform: "translateY(-4px)",
              }}
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              height="200px"
              cursor="pointer"
            >
              <AiOutlineUser size={48} color="#f97316" />
              <Text fontSize="lg" color="gray.800" mt={4} fontWeight="600">
                Account Issues
              </Text>
            </Box>
          </Link>

          {/* Support Topic 2 */}
          <Link
            to="/support/contact-us?type=vendor-dispute"
            style={{ textDecoration: "none" }}
          >
            <Box
              bg="white"
              border="1px solid"
              borderColor="gray.200"
              borderRadius="xl"
              p={8}
              textAlign="center"
              boxShadow="sm"
              transition="all 0.3s ease"
              _hover={{
                boxShadow: "xl",
                borderColor: "orange.400",
                transform: "translateY(-4px)",
              }}
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              height="200px"
              cursor="pointer"
            >
              <AiOutlineExclamationCircle size={48} color="#f97316" />
              <Text fontSize="lg" color="gray.800" mt={4} fontWeight="600">
                Vendor Dispute
              </Text>
            </Box>
          </Link>

          {/* Support Topic 3 */}
          <Link
            to="/support/contact-us?type=payment-issues"
            style={{ textDecoration: "none" }}
          >
            <Box
              bg="white"
              border="1px solid"
              borderColor="gray.200"
              borderRadius="xl"
              p={8}
              textAlign="center"
              boxShadow="sm"
              transition="all 0.3s ease"
              _hover={{
                boxShadow: "xl",
                borderColor: "orange.400",
                transform: "translateY(-4px)",
              }}
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              height="200px"
              cursor="pointer"
            >
              <AiOutlineFile size={48} color="#f97316" />
              <Text fontSize="lg" color="gray.800" mt={4} fontWeight="600">
                Documentation (Receipts)
              </Text>
            </Box>
          </Link>

          {/* Support Topic 4 */}
          <Link
            to="/support/contact-us?type=technical-problem"
            style={{ textDecoration: "none" }}
          >
            <Box
              bg="white"
              border="1px solid"
              borderColor="gray.200"
              borderRadius="xl"
              p={8}
              textAlign="center"
              boxShadow="sm"
              transition="all 0.3s ease"
              _hover={{
                boxShadow: "xl",
                borderColor: "orange.400",
                transform: "translateY(-4px)",
              }}
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              height="200px"
              cursor="pointer"
            >
              <AiOutlineBug size={48} color="#f97316" />
              <Text fontSize="lg" color="gray.800" mt={4} fontWeight="600">
                Technical Problems
              </Text>
            </Box>
          </Link>

          {/* Support Topic 5 */}
          <Link
            to="/support/contact-us?type=other"
            style={{ textDecoration: "none" }}
          >
            <Box
              bg="white"
              border="1px solid"
              borderColor="gray.200"
              borderRadius="xl"
              p={8}
              textAlign="center"
              boxShadow="sm"
              transition="all 0.3s ease"
              _hover={{
                boxShadow: "xl",
                borderColor: "orange.400",
                transform: "translateY(-4px)",
              }}
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              height="200px"
              cursor="pointer"
            >
              <AiOutlineQuestionCircle size={48} color="#f97316" />
              <Text fontSize="lg" color="gray.800" mt={4} fontWeight="600">
                General Inquiries
              </Text>
            </Box>
          </Link>

          {/* Support Topic 6 */}
          <Link to="/support/contact-us" style={{ textDecoration: "none" }}>
            <Box
              bg="white"
              border="1px solid"
              borderColor="gray.200"
              borderRadius="xl"
              p={8}
              textAlign="center"
              boxShadow="sm"
              transition="all 0.3s ease"
              _hover={{
                boxShadow: "xl",
                borderColor: "orange.400",
                transform: "translateY(-4px)",
              }}
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              height="200px"
              cursor="pointer"
            >
              <AiOutlinePhone size={48} color="#f97316" />
              <Text fontSize="lg" color="gray.800" mt={4} fontWeight="600">
                Contact Us
              </Text>
            </Box>
          </Link>
        </SimpleGrid>
      </Box>
    </Box>
  );
};

export default SupportPage;
